<template>
    <div class="row p-2 p-lg-4" id="overviews">
        <div class="col-12 px-2 px-lg-5">
            <CampaingsOverviews :warehouses="warehouses" />
            <ProductsExportOver class="my-4" :warehouses="warehouses" />
            <ProductsExportFullOver class="my-4" />
            <ProductsOverWarehouse class="my-4" />
            <ProductsOverCampaign class="my-4" />
            <CustomersExportOver class="my-4" :warehouses="warehouses" />
            <TransportOver class="my-4" />
            <WarehousesOver :warehouses="warehouses" />
            <ProductionOver class="my-4" :warehouses="warehouses" />
            <CollectedRevenueOver class="my-4" :warehouses="warehouses"/>
        </div>
    </div>
</template>
<script>
import WarehousesOver from "@/components/overviews/WarehousesOver.vue";
import ProductionOver from "@/components/overviews/ProductionOver.vue";
import CampaingsOverviews from "@/components/overviews/CampaingsOverviews.vue";
import CollectedRevenueOver from "@/components/overviews/CollectedRevenueOver.vue";
import ProductsExportOver from "@/components/overviews/ProductsExportOver.vue";
import CustomersExportOver from "@/components/overviews/CustomersExportOver.vue";
import ProductsExportFullOver from "@/components/overviews/ProductsExportFullOver.vue";
import ProductsOverCampaign from "@/components/overviews/ProductsOverCampaign.vue";
import ProductsOverWarehouse from "@/components/overviews/ProductsOverWarehouse.vue";
import TransportOver from "../components/overviews/TransportOver.vue";

export default {
    components: {
        WarehousesOver,
        ProductionOver,
        CampaingsOverviews,
        CollectedRevenueOver,
        ProductsExportOver,
        CustomersExportOver,
        ProductsExportFullOver,
        ProductsOverCampaign,
        ProductsOverWarehouse,
        TransportOver
    },
    data: function () {
        return {
            warehouses: []
        }
    },
    created: function () {
        this.getWarehouses();
    },
    methods: {
        getWarehouses: function () {
            this.$store.getters.api.get("/warehouses").then((response) => {
                this.warehouses = response.data.items;
            });
        }
    }
}
</script>
<style lang="">

</style>